(function () {

  // Add event listener to tabs to trigger the toggle function
const tabs = document.querySelectorAll('.qb-category-tab');
tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    if (tab.getAttribute('data-category') === 'pods-k-cup') {
      document.querySelector('.step-2-wrapper').style.display = 'none';
    }else{
      document.querySelector('.step-2-wrapper').style.display = '';
    }
  });
});


  // update 2
  // Allow JS-controlled reveal; avoids hiding content when JS is disabled
  document.documentElement.classList.add('js-armed');

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Collect animate.css classes on an element
  function extractAnimateClasses(el) {
    const anim = [];
    el.classList.forEach(cls => { if (cls.startsWith('animate__')) anim.push(cls); });
    return anim;
  }

  // Prepare element for on-scroll reveal
  function prepare(el) {
    const animClasses = extractAnimateClasses(el);
    if (!animClasses.length) return;

    // Save + remove to prevent initial autoplay
    el.dataset.animClasses = animClasses.join(' ');
    animClasses.forEach(c => el.classList.remove(c));
    el.classList.remove('animate__animated');

    if (!REDUCED) el.classList.add('aos-hide');
  }

  // Reveal/animate once
  function reveal(el) {
    if (el.dataset.animClasses) {
      el.classList.add('animate__animated');
      el.dataset.animClasses.split(' ').forEach(c => el.classList.add(c));
    }
    el.classList.remove('aos-hide');
  }

  function wireUp(elements) {
    if (!elements.length) return;

    if (REDUCED) {
      // Respect reduced motion: show content instantly
      elements.forEach(el => el.classList.remove('aos-hide'));
      return;
    }

    elements.forEach(prepare);

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target); // animate only once
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.2
    });

    elements.forEach(el => io.observe(el));
  }

  function init() {
    // Only target elements that *declare* animate.css classes
    const animatedEls = Array.from(document.querySelectorAll('[class*="animate__"]'));
    wireUp(animatedEls);

    // OPTIONAL: handle dynamically added content
    const mo = new MutationObserver(muts => {
      const newbies = [];
      muts.forEach(m => {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          // Node itself
          if (node.matches && node.matches('[class*="animate__"]')) newbies.push(node);
          // Any descendants
          newbies.push(...node.querySelectorAll?.('[class*="animate__"]') ?? []);
        });
      });
      if (newbies.length) wireUp(Array.from(new Set(newbies)));
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();







(function () {
  function init() {
    const DEBUG = false;
    const D = {
      log: (...a) => DEBUG && console.log('[QB]', ...a),
      warn: (...a) => DEBUG && console.warn('[QB]', ...a),
      error: (...a) => DEBUG && console.error('[QB]', ...a),
      group: (l) => DEBUG && console.group(l),
      groupEnd: () => DEBUG && console.groupEnd(),
    };

    // --- DOM ---
    const sectionRoot = document.getElementById('qb-brew-selector');
    if (!sectionRoot) return;

    const offerButtons = Array.from(sectionRoot.querySelectorAll('.qb-option-card'));
    const variantWrap = sectionRoot.querySelector('#qb-variant-options');
    const qtyWrap = sectionRoot.querySelector('#qb-qty-options');
    const btnCheckout = sectionRoot.querySelector('#qb-checkout-btn');

    // Currency (kept)
    const currency =
      (sectionRoot && sectionRoot.dataset.currency) ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'USD';

    // New CTA
    const lpButton = sectionRoot.querySelector('.lp-button') || sectionRoot.querySelector('#lp-button');
    const lpPrice = sectionRoot.querySelector('#lp-price') || sectionRoot.querySelector('.lp-price');

    // Summary (still hidden but maintained)
    const elTitle = document.getElementById('qb-summary-title');
    const elPrices = document.getElementById('qb-summary-prices');
    const elShip = document.getElementById('qb-summary-shipping');
    const elOld = document.getElementById('qb-summary-price-old');
    const elNew = document.getElementById('qb-summary-price-new');
    const elShipOld = document.getElementById('qb-summary-ship-old');
    const elShipNew = document.getElementById('qb-summary-ship-new');

    // Qty chip numbers
    const qtyTotals = sectionRoot.querySelectorAll('.qb-price-total');
    const qtyPerBags = sectionRoot.querySelectorAll('.qb-price-perbag');

  // --- state ---
  const productCache = new Map(); // handle -> product json
  // Promise cache to coalesce identical in-flight fetches: handle -> Promise(productJson)
  const productFetchPromises = new Map();
  // Per-qty price memoization: key `${handle}|${qty}|${variantId}` -> unitPriceCents
  const perQtyPriceCache = new Map();
  // Active AbortController for the current selection flow. Abort when selection changes.
  let activeFetchController = null;
    let selectedCardBtn = null;     // Step 1
    let selectedProduct = null;     // current product (same for both qty options)
    let selectedVariant = null;     // { id, title, price } — price = per bag
    let selectedQty = 3;        // 3 or 6
    let preferredVariantKey = null; // restore across products
    let lastSelectedGrindKey = null; // Persist grind selection across bundle switches
    const SHIPPING_VALUE = 6.95;

    // Mixed bundle state
    let isMixedBundle = false;
    // Operation token to avoid stale async updates when selection changes
    let currentSelectionToken = 0;
    // No longer needed: let mixedBundleHandles = [];
    // No longer needed: let mixedBundleVariants = [];
    let mixedBundleOptionName = 'Grind'; // Change if your option is named differently
    const isEspressoPromotionsPage = (() => {
      const path = (window.location && window.location.pathname) ? window.location.pathname.replace(/\/+$/, '') : '';
      return path === '/pages/espresso-promotions';
    })();

    // --- helpers ---
    const centsToNumber = (c) => (Number(c) || 0) / 100;
    const numberToCents = (n) => Math.round((Number(n) || 0) * 100);
    const discountRate = (qty) => (qty >= 6 ? 0.25 : 0.20);
    const bundleLabel = (qty) => (qty >= 6 ? '6-Bag Bundle' : '3-Bag Bundle');
    const variantKeyFromVariant = (v) => (v.title || v.option1 || '').trim().toLowerCase();

    function getQtyPercentRate(qty) {
      let percentRate = null;
      try {
        var tabs = document.querySelectorAll('.qb-category-tab');
        var firstCategory = tabs[0] ? tabs[0].getAttribute('data-category') : null;
        var fourthCategory = tabs[3] ? tabs[3].getAttribute('data-category') : null;
        var fifthCategory = tabs[4] ? tabs[4].getAttribute('data-category') : null;
        var cardCategory = null;
        if (selectedCardBtn) {
          const wrapper = selectedCardBtn.closest && selectedCardBtn.closest('.qb-offer-card');
          cardCategory = wrapper ? wrapper.getAttribute('data-category') : null;
        }
        if (cardCategory && ((firstCategory && firstCategory === cardCategory) || (fourthCategory && fourthCategory === cardCategory) || (fifthCategory && fifthCategory === cardCategory))) {
          const qtyBtn = sectionRoot.querySelector(`.qb-chip[data-qty="${qty}"]`);
          if (qtyBtn && qtyBtn.dataset && qtyBtn.dataset.rate) percentRate = Number(qtyBtn.dataset.rate);
        }
      } catch (e) { percentRate = null; }
      return percentRate;
    }

    function sanitizeVariantTitle(t) {
      if (!t) return t;
      // Remove trailing '· 12 oz/bag' and similar variations (flexible spacing/slash)
      try {
        return String(t).replace(/\s*·\s*\d+\s*oz\s*\/?\s*bag\s*$/i, '').trim();
      } catch (e) { return t; }
    }

    function normalizeUrl(u) { if (!u) return u; return u.startsWith('//') ? (window.location.protocol + u) : u; }

    // Quick visibility check that respects display:none ancestors
    const isVisible = (el) => !!(el && (el.offsetParent || el.getClientRects().length));

    function money(amount) {
      const parts = new Intl.NumberFormat(undefined, {
        style: 'currency', currency, currencyDisplay: 'narrowSymbol'
      }).formatToParts(amount);
      return parts.map(p => p.type === 'currency' ? p.value.replace(/^US\$/, '$') : p.value).join('');
    }

    // prevent ribbons/check icons from eating clicks
    function safeHitAreas() {
      sectionRoot.querySelectorAll('.qb-check-icon, .qb-ribbon').forEach(el => { el.style.pointerEvents = 'none'; });
    }

    // Schedule a simulated click on the currently selected Step-1 card
    // after a small delay (100-200ms). Used as a UI refresh hotfix when
    // the user picks a variant (step 2) or qty (step 3).
    function scheduleReselectCard() {
      try {
        const selected = sectionRoot.querySelector('.qb-option-card.is-selected') || selectedCardBtn;
        if (!selected) return;
        const delay = 100 + Math.floor(Math.random() * 101); // 100-200ms
        setTimeout(() => {
          try { if (selected && typeof selected.click === 'function') selected.click(); } catch (e) { /* ignore */ }
        }, delay);
      } catch (e) { /* defensive */ }
    }

    // Clear visible prices and show a neutral placeholder while new data loads
    function showLoadingState(){
      // Hide summary prices
      if (elPrices) elPrices.style.display = 'none';
      if (elShip) elShip.style.display = 'none';
      if (elOld) elOld.textContent = '';
      if (elNew) elNew.textContent = '';
      // Clear qty chip price texts so old numbers don't persist
      [1,3,6].forEach(q => {
        const orig = sectionRoot.querySelector(`.qb-price-original[data-for-qty="${q}"]`);
        const total = sectionRoot.querySelector(`.qb-price-total[data-for-qty="${q}"]`);
        const per = sectionRoot.querySelector(`.qb-price-perbag[data-for-qty="${q}"]`);
        if (orig) orig.textContent = '';
        if (total) total.textContent = '';
        if (per) per.textContent = '';
      });
      // Disable main CTA until prices resolved
      setLPButton(0, false);
    }

    // Are all selections made?
    const allReady = () => !!(selectedCardBtn && selectedVariant);

    function setLPButton(amount, enabled) {
      if (!lpButton) return;
      const priceText = enabled ? money(amount) : '';
      if (lpPrice) {
        lpPrice.textContent = priceText;
      } else {
        const iconHTML = lpButton.querySelector('i') ? lpButton.querySelector('i').outerHTML : '';
        const raw = lpButton.textContent || '';
        const base = raw.replace(/\{price\}/gi, '').replace(/\s+-\s*$/, '').trim();
        lpButton.innerHTML = enabled
          ? `${base} - ${priceText} ${iconHTML}`.trim()
          : `${base} ${iconHTML}`.trim();
      }
      lpButton.disabled = !enabled;
      lpButton.classList.toggle('is-disabled', !enabled);
    }

    // Trigger the existing side-cart UI if present; fall back to directly toggling classes
    function openSideCart() {
      const cartTrigger = document.querySelector('.site-header-cart--button');
      if (cartTrigger) {
        cartTrigger.click();
        return;
      }

      // Fallback: directly open the cart drawer
      const cart = document.getElementById('side-cart');
      const backdrop = document.getElementById('side-cart-backdrop');
      if (cart) cart.classList.add('open');
      if (backdrop) backdrop.classList.add('visible');
      document.body.classList.add('side-cart-open');
    }

    // ---------- PRICE LOGIC (now per-bag) ----------
    // We now treat variant.price as *per bag*. Totals = unit * qty, then discount.
    // function calcTotals(unitPriceCents, qty){
    //   const rate     = discountRate(qty);
    //   const full     = unitPriceCents * qty;                 // original price for qty bags
    //   const discounted = Math.round(full * (1 - rate));      // discounted total
    //   const perBag   = Math.round(discounted / qty);         // discounted per bag
    //   const savings  = full - discounted;                    // savings in cents
    //   return { full, discounted, perBag, savings, rate };
    // }

    // >>>>>>>>>>> CORRECT PRICE LOGIC (per-bag). For 6 bags: $1 off per bag BEFORE the 25% discount.
    // function calcTotals(unitPriceCents, qty){
    //   const rate = discountRate(qty);        // 0.20 or 0.25

    //   // "full" = original anchor price (no $1 off, no % off) → for strike-through & savings calc
    //   const full = unitPriceCents * qty;

    //   // Apply the $1-per-bag reduction ONLY for 6-bag math, BEFORE the 25% off
    //   const unitForDiscount = (qty >= 6) ? Math.max(unitPriceCents - 100, 0) : unitPriceCents;

    //   // Now apply the % off to that pre-adjusted total
    //   const baseForDiscount = unitForDiscount * qty;
    //   const discounted = Math.round(baseForDiscount * (1 - rate));

    //   const perBag  = Math.round(discounted / qty);
    //   const savings = full - discounted;     // includes both the $1-off-per-bag and the % discount

    //   return { full, discounted, perBag, savings, rate };
    // }

    // PRICE LOGIC (per-bag).
    // If `percentRate` is provided (e.g. 0.20 for 20%), use percent-based
    // math: discounted = full * (1 - percentRate). Otherwise fall back to
    // the legacy fixed-cent savings behavior.
    function calcTotals(unitPriceCents, qty, percentRate = null) {
      const full = unitPriceCents * qty;   // original (no discount)
      let discounted = full;
      let savings = 0;
      let rate = null;

      if (percentRate !== null && !Number.isNaN(Number(percentRate))) {
        rate = Number(percentRate);
        discounted = Math.round(full * (1 - rate));
        savings = full - discounted;
      } else {
        // Legacy fixed-cent savings
        if (qty === 1) {
          savings = 0;
          discounted = full;
        } else if (qty === 3) {
          savings = 1490; // $14.90?? kept legacy value (developer can change)
          discounted = full - savings;
        } else if (qty === 6) {
          savings = 3426; // legacy cents
          discounted = full - savings;
        }
      }

      if (discounted < 0) discounted = 0; // guard

      const perBag = Math.round(discounted / qty);

      return { full, discounted, perBag, savings, rate };
    }



    function updateSummary() {
      if (selectedProduct && selectedVariant && selectedCardBtn) {
        const directMixedPricing = isMixedBundle && isEspressoPromotionsPage;
        const bundlePriceCents = Number(selectedVariant.price) || 0;

        // Legacy pages keep treating mixed bundle variants as if they were per-bag prices.
        if (isMixedBundle) {
          updateRowClass('mixed');
        } else {
          updateRowClass('regular');
        }

        if (directMixedPricing) {
          const totalCents = bundlePriceCents;
          const originalCents =
            Number(selectedVariant.compareAtPrice) > totalCents
              ? Number(selectedVariant.compareAtPrice)
              : totalCents;
          const percentRate = discountRate(selectedQty) || getQtyPercentRate(selectedQty);
          const discountedCents = percentRate
            ? Math.round(originalCents * (1 - percentRate))
            : totalCents;
          const rawTitle = (selectedCardBtn?.getAttribute('data-product-title') || selectedProduct.title || '');
          const baseTitle = sanitizeVariantTitle(String(rawTitle)).replace(/^\s*\d+x\s*/i, '').trim();
          if (elTitle) elTitle.textContent = `${bundleLabel(selectedQty)} — ${baseTitle}`;

          if (elOld) elOld.textContent = money(originalCents / 100);
          if (elNew) elNew.textContent = money(discountedCents / 100);
          if (elShipOld) elShipOld.textContent = money(SHIPPING_VALUE);
          if (elShipNew) elShipNew.textContent = 'Free Shipping';
          if (elPrices) elPrices.style.display = '';
          if (elShip) elShip.style.display = '';

          if (btnCheckout) {
            btnCheckout.innerHTML =
              `Complete My Order — ${money(discountedCents / 100)} <small class="ms-1">(Free Shipping included)</small>`;
          }

          setLPButton(discountedCents / 100, true);
          updateQtyPriceBoxes(totalCents, selectedQty);
          return;
        }

        const legacyUnitCents = (isMixedBundle && selectedQty > 0)
          ? Math.round(bundlePriceCents / selectedQty)
          : bundlePriceCents;

        // Determine whether percent-based math should be used for this selection.
        // Use the first category tab (left-most) OR the 4th tab as controllers for
        // percent-based behavior. If the selected card's category matches either
        // tab 1 or tab 4, we read the `data-rate` from the qty chip and use
        // percent-based math. This allows tab 4 to behave like tab 1.
        let percentRate = null;
        try {
          var tabs = document.querySelectorAll('.qb-category-tab');
          var firstCategory = tabs[0] ? tabs[0].getAttribute('data-category') : null;
          var fourthCategory = tabs[3] ? tabs[3].getAttribute('data-category') : null;
          var fifthCategory = tabs[4] ? tabs[4].getAttribute('data-category') : null;
          var cardCategory = null;
          if (selectedCardBtn) {
            // category is rendered on the wrapper `.qb-offer-card` element
            const wrapper = selectedCardBtn.closest && selectedCardBtn.closest('.qb-offer-card');
            cardCategory = wrapper ? wrapper.getAttribute('data-category') : null;
          }
          // If the card's category matches either the first or fourth tab, use percentRate
          if (cardCategory && ((firstCategory && firstCategory === cardCategory) || (fourthCategory && fourthCategory === cardCategory) || (fifthCategory && fifthCategory === cardCategory))) {
            const qtyBtn = sectionRoot.querySelector(`.qb-chip[data-qty="${selectedQty}"]`);
            if (qtyBtn && qtyBtn.dataset && qtyBtn.dataset.rate) percentRate = Number(qtyBtn.dataset.rate);
          }
          if (window.DEBUG_QB) console.log('[QB] percentRate detection:', { firstCategory, fourthCategory, cardCategory, percentRate });
        } catch (e) { percentRate = null; }

        const { discounted, rate } = calcTotals(legacyUnitCents, selectedQty, percentRate);
        // Hotfix: for tab 4 only, increase the final displayed price for 6x by 3 cents.
        // This intentionally adjusts only the final shown total (discounted) for UX
        // reasons — it does not change the percentRate or base discount calculation.
        let finalDiscounted = discounted;
        try {
          // tabs and categories were computed above; reuse them if present
          // Only apply hotfix for regular (non-mixed) offers in tab 4 and qty=6
          const isCardMixed = selectedCardBtn && selectedCardBtn.getAttribute && selectedCardBtn.getAttribute('data-bundle-type') === 'mixed';
          if (typeof fourthCategory !== 'undefined' && typeof cardCategory !== 'undefined') {
            if (cardCategory && fourthCategory && cardCategory === fourthCategory && selectedQty === 6 && !isCardMixed) {
              finalDiscounted = discounted + 3; // add 3 cents
            }
          }
        } catch (e) { /* be defensive — fall back to original discounted */ }

        const rawTitle = (selectedCardBtn?.getAttribute('data-product-title') || selectedProduct.title || '');
        const baseTitle = sanitizeVariantTitle(String(rawTitle)).replace(/^\s*\d+x\s*/i, '').trim();
        if (elTitle) elTitle.textContent = `${bundleLabel(selectedQty)} — ${baseTitle}`;

        if (elOld) elOld.textContent = money((legacyUnitCents * selectedQty) / 100);
        if (elNew) elNew.textContent = money(finalDiscounted / 100);
        if (elShipOld) elShipOld.textContent = money(SHIPPING_VALUE);
        if (elShipNew) elShipNew.textContent = 'Free Shipping';
        if (elPrices) elPrices.style.display = '';
        if (elShip) elShip.style.display = '';

        const pct = rate === 0.25 ? '25%' : '20%';
        if (btnCheckout) {
          btnCheckout.innerHTML =
            `Complete My Order — ${money(finalDiscounted / 100)} <small class="ms-1">(${pct} Off + Free Shipping included)</small>`;
        }

        // Drive main CTA (pass final displayed price)
        setLPButton(finalDiscounted / 100, true);

        // keep qty chips fresh for the *current* qty too
        updateQtyPriceBoxes(legacyUnitCents, selectedQty);
      } else if (selectedCardBtn) {
        if (elTitle) elTitle.textContent = selectedCardBtn.getAttribute('data-product-title') || 'Selected coffee';
        if (elPrices) elPrices.style.display = 'none';
        if (elShip) elShip.style.display = 'none';
        if (btnCheckout) {
          btnCheckout.innerHTML =
            '{{ section.settings.cta_label | escape }} <i class="bi bi-arrow-right ms-2"></i>';
        }
        setLPButton(0, false);
      } else {
        if (elTitle) elTitle.textContent = '0 selected';
        if (elPrices) elPrices.style.display = 'none';
        if (elShip) elShip.style.display = 'none';
        if (btnCheckout) {
          btnCheckout.innerHTML =
            '{{ section.settings.cta_label | escape }} <i class="bi bi-arrow-right ms-2"></i>';
        }
        setLPButton(0, false);
      }
    }

    // Update the numbers inside a single qty chip (given unit price)
    function updateQtyPriceBoxes(unitPriceCents, qty) {
      const directMixedPricing = isMixedBundle && isEspressoPromotionsPage;
      const percentRate = getQtyPercentRate(qty);
      let cardCategory = null;
      let fourthCategory = null;
      try {
        const tabs = document.querySelectorAll('.qb-category-tab');
        fourthCategory = tabs[3] ? tabs[3].getAttribute('data-category') : null;
        if (selectedCardBtn) {
          const wrapper = selectedCardBtn.closest && selectedCardBtn.closest('.qb-offer-card');
          cardCategory = wrapper ? wrapper.getAttribute('data-category') : null;
        }
      } catch (e) { /* ignore */ }

      if (directMixedPricing) {
        const full = unitPriceCents;
        const original = Number(selectedVariant.compareAtPrice) > full
          ? Number(selectedVariant.compareAtPrice)
          : full;
        const percentRate = discountRate(qty) || getQtyPercentRate(qty);
        const discounted = percentRate
          ? Math.round(original * (1 - percentRate))
          : full;
        const perBag = qty > 0 ? Math.round(discounted / qty) : discounted;
        const savings = Math.max(original - discounted, 0);
        const totalEl = sectionRoot.querySelector(`.qb-price-total[data-for-qty="${qty}"]`);
        const perBagEl = sectionRoot.querySelector(`.qb-price-perbag[data-for-qty="${qty}"]`);
        const saveEl = sectionRoot.querySelector(`.qb-price-save[data-for-qty="${qty}"]`);
        const origEl = sectionRoot.querySelector(`.qb-price-original[data-for-qty="${qty}"]`);

        if (origEl) origEl.textContent = money(original / 100);
        if (totalEl) totalEl.textContent = money(discounted / 100);
        if (perBagEl) perBagEl.textContent = money(perBag / 100);
        if (saveEl) saveEl.textContent = money(savings / 100);
        return;
      }

      const { full, discounted, perBag, savings } = calcTotals(unitPriceCents, qty, percentRate);

      // Apply same tiny hotfix for tab 4: +3 cents to the final displayed total for 6x
      let finalDiscounted = discounted;
      let finalPerBag = perBag;
      let finalSavings = savings;
      try {
        const isCardMixed = selectedCardBtn && selectedCardBtn.getAttribute && selectedCardBtn.getAttribute('data-bundle-type') === 'mixed';
        if (cardCategory && fourthCategory && cardCategory === fourthCategory && qty === 6 && !isCardMixed) {
          finalDiscounted = discounted + 3;
          finalPerBag = Math.round(finalDiscounted / qty);
          finalSavings = full - finalDiscounted;
        }
      } catch (e) { /* ignore and keep original values */ }

      const totalEl = sectionRoot.querySelector(`.qb-price-total[data-for-qty="${qty}"]`);
      const perBagEl = sectionRoot.querySelector(`.qb-price-perbag[data-for-qty="${qty}"]`);
      const saveEl = sectionRoot.querySelector(`.qb-price-save[data-for-qty="${qty}"]`);
      const origEl = sectionRoot.querySelector(`.qb-price-original[data-for-qty="${qty}"]`);

      if (origEl) origEl.textContent = money(full / 100);
      if (totalEl) totalEl.textContent = money(finalDiscounted / 100);
      if (perBagEl) perBagEl.textContent = money(finalPerBag / 100);
      if (saveEl) saveEl.textContent = money(finalSavings / 100);
    }

    // Set chip price block for 3 and 6 using a unit price (per bag)
    function setQtyChipPrice(qty, unitPriceCents) {
      if (window.DEBUG_QB) {
        console.log(`[QB DEBUG] setQtyChipPrice called for qty=${qty}, unitPriceCents=${unitPriceCents}`);
      }
      updateQtyPriceBoxes(unitPriceCents, qty);
    }

    // ---------- products / variants ----------
    // Fetch product JSON with optional AbortSignal. Coalesce identical requests using productFetchPromises.
    async function fetchProduct(handle, signal){
      if (!handle) throw new Error('Missing product handle');
      // Return cached JSON if available
      if (productCache.has(handle)) return productCache.get(handle);
      // Return existing in-flight promise if present
      if (productFetchPromises.has(handle)) return productFetchPromises.get(handle);

      const p = (async () => {
        const res = await fetch(`/products/${handle}.js`, { headers: { Accept:'application/json' }, signal });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const json = await res.json();
        productCache.set(handle, json);
        productFetchPromises.delete(handle);
        return json;
      })();

      // Store promise to coalesce duplicate requests
      productFetchPromises.set(handle, p);

      // Ensure we cleanup on rejection so future attempts can retry
      p.catch(() => { productFetchPromises.delete(handle); });
      return p;
    }

    // We only have ONE product per card now (no separate 3x/6x)
    function productHandleFromCard(btn) {
      return btn.getAttribute('data-product-handle')
        || btn.getAttribute('data-product-handle-3')
        || btn.getAttribute('data-product-handle-6'); // fallback if markup still has it
    }

    function getQtyOptionContainer(chip) {
      if (!chip) return null;
      return chip.closest('[class*="col-"]') || chip.parentElement;
    }

    function setOneBagOptionVisibility(hidden) {
      if (!qtyWrap) return;

      const oneChip = qtyWrap.querySelector('.qb-chip[data-qty="1"]');
      const oneContainer = getQtyOptionContainer(oneChip);
      const target = oneContainer || oneChip;
      if (!target) return;

      target.style.display = hidden ? 'none' : '';

      if (hidden) {
        target.setAttribute('aria-hidden', 'true');
      } else {
        target.removeAttribute('aria-hidden');
      }
    }

    function getLockCartQuantityProperties(btn, qty) {
      if (!btn) return {};

      let flag;
      if (qty === 1) {
        flag = btn.getAttribute('data-lock-cart-quantity-1');
      } else if (qty === 6) {
        flag = btn.getAttribute('data-lock-cart-quantity-6');
      } else {
        flag = btn.getAttribute('data-lock-cart-quantity-3');
      }

      if (flag == null && qty === 1) {
        flag = btn.getAttribute('data-lock-cart-quantity-3');
      }

      if (flag === 'true' || flag === '1') {
        return { _lock_cart_quantity: 'true' };
      }

      return {};
    }

    const variantImages = [
      // 'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Fresh-beans.png?v=1744239315',
      // 'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Medium-Grind-Ground_a56a2fa2-7436-4475-9b67-25d31f8e0291.png?v=1746121579',
      // 'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Pods-grind-coffee.png?v=1744239477',
      // 'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Espresso-Fine-grind.png?v=1744239221',
      'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/icon-whole-bean.png?v=1759442173',
      'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/icon-ground.png?v=1759442173',
      'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/icon-pod-grind.png?v=1759442172',
      'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/icon-espresso-grind.png?v=1759442173',
      'https://cdn.shopify.com/s/files/1/0570/8359/2807/files/icon-k-cups.png?v=1759442173'
    ];



    const variantDescriptionsByIndex = [
      'Grind fresh at home',
      'Drip, pour-over & press',
      'For reusable pods',
      'Fine grind for espresso',
      'K-Cup description'
    ];

    // Helper to pick an image for a variant based on its key/title
    function imageForVariant(v, fallbackIdx) {
      const title = (v && (v.title || v.option1 || '')).toString().toLowerCase();
      const key = variantKeyFromVariant(v || {});
      if (/pod|k-?cup/.test(key) || /pod|k-?cup/.test(title)) return variantImages[2];
      if (/espresso/.test(key) || /espresso/.test(title)) return variantImages[3];
      if (/ground|grounded/.test(key) || /ground/.test(title)) return variantImages[1];
      return variantImages[fallbackIdx] || variantImages[0];
    }

    // Helper to pick a short description for a variant based on its key/title
    function descForVariant(v) {
      const title = (v && (v.title || v.option1 || '')).toString().toLowerCase();
      const key = variantKeyFromVariant(v || {});
      if (/pod|k-?cup/.test(key) || /pod|k-?cup/.test(title)) return 'For reusable pods';
      if (/espresso/.test(key) || /espresso/.test(title)) return 'Fine grind for espresso';
      if (/ground|grounded/.test(key) || /ground/.test(title)) return 'Drip, pour-over & press';
      return 'Grind fresh at home';
    }

    function renderVariants(product) {
      // Capture current token to avoid rendering stale variant lists
      const tokenAtCall = currentSelectionToken;
      // Debug: log when renderVariants runs and what preferredVariantKey is
      console.log('[QB] renderVariants called. isMixedBundle:', isMixedBundle, 'preferredVariantKey:', preferredVariantKey, 'tokenAtCall:', tokenAtCall);
      // Mixed bundle: render grind types only once, not all variants
      if (isMixedBundle && product && product.variants && product.options) {
        let grindIdx = product.options.findIndex(opt => opt.name.toLowerCase() === mixedBundleOptionName.toLowerCase());
        if (grindIdx === -1) grindIdx = 0;
        let grindMap = new Map();
        product.variants.forEach((v) => {
          const grindValue = v[`option${grindIdx + 1}`];
          const grindKey = (grindValue || '').trim().toLowerCase();
          // Exclude pod/k-cup grind options
          if (/pod|k-?cup/.test(grindKey)) return;
          if (grindValue && !grindMap.has(grindKey)) {
            grindMap.set(grindKey, { value: grindValue, variant: v });
          }
        });
        const grindOptions = Array.from(grindMap.values());
        // Abort if selection changed while we were preparing
        if (tokenAtCall !== currentSelectionToken) return;
        variantWrap.innerHTML = '';
        // Build DOM off-DOM and append once to avoid partial flashes
        const frag = document.createDocumentFragment();
          for (let idx = 0; idx < grindOptions.length; idx++) {
          if (tokenAtCall !== currentSelectionToken) break;
          const opt = grindOptions[idx];
          const col = document.createElement('div');
          col.className = 'col-4 col-md-3'; // removed Pods
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qb-chip rounded-3 btn border w-100 py-3';
          btn.dataset.grindValue = opt.value;
          btn.dataset.variantId = opt.variant.id;
          btn.dataset.variantTitle = sanitizeVariantTitle(opt.variant.title);
          btn.dataset.variantPrice = opt.variant.price;
          btn.dataset.variantCompareAtPrice = opt.variant.compare_at_price || 0;
          btn.dataset.variantKey = (opt.value || '').trim().toLowerCase();
          const imgSrc = imageForVariant(opt.variant, idx) || '';
          const prettyTitle = opt.value;
          const desc = descForVariant(opt.variant) || '';
          btn.innerHTML = `
            <span class="qb-check-icon"><i class="bi bi-check-circle-fill"></i></span>
            ${imgSrc ? `<img src="${imgSrc}" alt="${prettyTitle}" class="img-fluid mb-2 qb-variant-image">` : ''}
            <div class="qb-variant-title mb-2 fw-bold">${prettyTitle}</div>
            ${desc ? `<div class="qb-variant-desc">${desc}</div>` : ''}
          `;
          col.appendChild(btn);
          frag.appendChild(col);
        }
        if (tokenAtCall !== currentSelectionToken) return;
        variantWrap.appendChild(frag);
        // Debug: always log preferredVariantKey and available chips
        console.log('[QB] preferredVariantKey:', preferredVariantKey);
        const allChips = Array.from(variantWrap.querySelectorAll('.qb-chip'));
        console.log('[QB] allChips:', allChips.map(b => b.dataset.variantKey));
        let preBtn = null;
        if (preferredVariantKey) {
          preBtn = allChips.find(b => (b.dataset.variantKey || '').trim().toLowerCase() === preferredVariantKey);
        }
        // If no grind is selected, auto-select the first chip
        if (!preBtn && allChips.length > 0) {
          preBtn = allChips[0];
          preferredVariantKey = preBtn.dataset.variantKey;
          lastSelectedGrindKey = preferredVariantKey;
          console.log('[QB] Auto-selecting first grind chip:', preferredVariantKey);
        }
        console.log('[QB] preBtn:', preBtn);
        if (preBtn) {
          preBtn.classList.add('qb-chip--active');
          // Set selectedVariant as if user clicked
          const grindValue = preBtn.dataset.grindValue;
          const variant = product.variants.find(v => {
            return product.options.every((opt, idx) => {
              const val = v[`option${idx + 1}`];
              return (val || '').trim().toLowerCase() === preferredVariantKey;
            });
          });
          console.log('[QB] auto-selected variant:', variant);
          if (variant) {
            selectedVariant = {
              id: variant.id,
              title: sanitizeVariantTitle(variant.title),
              price: Number(variant.price) || 0,
              compareAtPrice: Number(variant.compare_at_price) || 0,
            };
          } else {
            selectedVariant = null;
          }
        }
        safeHitAreas();
        if (tokenAtCall !== currentSelectionToken) return;
        updateSummary();
        return;
      }
      // ...existing code for regular bundles...
      // Abort if selection changed
      if (tokenAtCall !== currentSelectionToken) return;
      variantWrap.innerHTML = '';
      if (!product || !product.variants || !product.variants.length) {
        variantWrap.innerHTML = '<div class="col-12 text-center text-muted">No variants</div>';
        selectedVariant = null;
        updateSummary();
        return;
      }
      const previewMode = !selectedCardBtn;
      // Build DOM off-DOM, then append once
      const frag = document.createDocumentFragment();
      for (let idx = 0; idx < product.variants.length; idx++) {
        if (tokenAtCall !== currentSelectionToken) break;
        const v = product.variants[idx];
        const vKey = variantKeyFromVariant(v);
        // Skip pod / k-cup variants entirely
        if (/pod|k-?cup/.test(vKey)) continue;
        const col = document.createElement('div');
        col.className = 'col-4 col-md-3';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qb-chip rounded-3 btn border w-100 py-3';
        btn.dataset.variantId = v.id;
  btn.dataset.variantTitle = sanitizeVariantTitle(v.title);
        btn.dataset.variantPrice = v.price; // per bag
        btn.dataset.variantCompareAtPrice = v.compare_at_price || 0;
        btn.dataset.variantKey = vKey;
        const isExplicitlyOOS = Object.prototype.hasOwnProperty.call(v, 'available') && v.available === false;
        const shouldDisable = !previewMode && isExplicitlyOOS;
        btn.classList.toggle('qb-chip--disabled', shouldDisable);
        if (shouldDisable) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
        const imgSrc = imageForVariant(v, idx) || '';
        const prettyTitle = v.title === 'Default Title' ? 'Standard' : sanitizeVariantTitle(v.title);
        const desc = descForVariant(v) || '';
        btn.innerHTML = `
          <span class="qb-check-icon"><i class="bi bi-check-circle-fill"></i></span>
          ${imgSrc ? `<img src="${imgSrc}" alt="${prettyTitle}" class="img-fluid mb-2 qb-variant-image">` : ''}
          <div class="qb-variant-title mb-2 fw-bold">${prettyTitle}</div>
          ${desc ? `<div class="qb-variant-desc">${desc}</div>` : ''}
        `;
        col.appendChild(btn);
        frag.appendChild(col);
      }
      if (tokenAtCall !== currentSelectionToken) return;
      variantWrap.appendChild(frag);
      safeHitAreas();
      // ...existing code for regular bundles...
      function activateVariant(btn, persist) {
        variantWrap.querySelectorAll('.qb-chip').forEach(c => c.classList.remove('qb-chip--active'));
        btn.classList.add('qb-chip--active');
        if (persist) {
          selectedVariant = {
            id: btn.dataset.variantId,
            title: btn.dataset.variantTitle,
            price: Number(btn.dataset.variantPrice) || 0,
            compareAtPrice: Number(btn.dataset.variantCompareAtPrice) || 0,
          };
        }
      }
      // restore preference
      let preBtn = null;
      if (preferredVariantKey) {
        preBtn = Array.from(variantWrap.querySelectorAll('.qb-chip'))
          .find(b => !b.classList.contains('qb-chip--disabled') &&
            (b.dataset.variantKey || '').toLowerCase() === preferredVariantKey);
      }
      if (selectedCardBtn) {
        if (preBtn) {
          activateVariant(preBtn, true);
        } else {
          const firstAvailable = variantWrap.querySelector('.qb-chip:not(.qb-chip--disabled)');
          if (firstAvailable) activateVariant(firstAvailable, true);
          else selectedVariant = null;
        }
      } else {
        const firstAvailable = variantWrap.querySelector('.qb-chip:not(.qb-chip--disabled)');
        if (firstAvailable) activateVariant(firstAvailable, false); // visual only
        selectedVariant = null;
      }
      updateSummary();
    }

    async function loadProductForCurrentSelection() {
      if (!selectedCardBtn) { updateSummary(); return; }
      const handle = productHandleFromCard(selectedCardBtn);
      try {
        const tokenBeforeFetch = currentSelectionToken;
        const signal = activeFetchController ? activeFetchController.signal : undefined;
        const product = await fetchProduct(handle, signal);
        if (tokenBeforeFetch !== currentSelectionToken) return; // selection changed
        selectedProduct = product;
        renderVariants(product);
      } catch (e) {
        console.error('Failed to load product JSON', e);
        variantWrap.innerHTML = '<div class="col-12 text-center text-danger">Could not load variants</div>';
        selectedProduct = null;
        selectedVariant = null;
        updateSummary();
      }
    }

    async function selectOffer(button) {
      // Invalidate any in-flight pricing/variant updates
  currentSelectionToken++;
  // Cancel any previous network work for an earlier selection and start a fresh controller
  try { if (activeFetchController) activeFetchController.abort(); } catch(e){}
  activeFetchController = new AbortController();
  // clear visible prices while we load the new product
  showLoadingState();
      offerButtons.forEach(b => b.classList.remove('is-selected', 'qb-option-card--active'));
      button.classList.add('is-selected', 'qb-option-card--active');
      selectedCardBtn = button;

  // Detect bundle type
  const bundleType = button.getAttribute('data-bundle-type');
  const wasMixed = isMixedBundle;
  isMixedBundle = bundleType === 'mixed';

  // Prevent using a stale selectedVariant (for example a mixed-bundle variant
  // whose price represents a bundle total) while we asynchronously fetch the
  // new product. Clear selection and refresh summary immediately so the UI
  // doesn't multiply a bundle-total by qty when bundle type flips.
  selectedVariant = null;
  selectedProduct = null;
  updateSummary();

      // Restore grind selection if available
      if (!preferredVariantKey && lastSelectedGrindKey) {
        console.log('[QB] Restoring preferredVariantKey from lastSelectedGrindKey:', lastSelectedGrindKey);
        preferredVariantKey = lastSelectedGrindKey;
      }

    if (qtyWrap) {
      qtyWrap.style.display = '';
      qtyWrap.removeAttribute('aria-hidden');
      setOneBagOptionVisibility(isMixedBundle);
    }

    // Mixed bundles do not allow 1 bag, so move back to 3 if needed.
    if (isMixedBundle && selectedQty === 1) {
      selectedQty = 3;
      updateLabelBasedOnQty(selectedQty);
    }

    if (isMixedBundle) {
        // For mixed bundles prefer the 3-bag product by default (or 6 if previously selected)
        const qty = selectedQty === 6 ? 6 : 3;
        const handle = qty === 6 ? button.getAttribute('data-product-handle-6') : button.getAttribute('data-product-handle-3');
        if (!handle) return;
        // capture token to avoid rendering stale results
        const tokenBeforeFetch = currentSelectionToken;
        // Use the active controller's signal so this fetch can be aborted if the selection changes
        await fetchProduct(handle, activeFetchController.signal);
        if (tokenBeforeFetch !== currentSelectionToken) return; // selection changed while fetching
        const mixedProduct = productCache.get(handle);
        selectedProduct = mixedProduct;
        renderVariants(mixedProduct);
        // Ensure the qty chip for the chosen qty is visually active (e.g. 3-bag)
        if (qtyWrap) {
          try {
            qtyWrap.querySelectorAll('.qb-chip').forEach(c => c.classList.remove('qb-chip--active'));
            const chosenChip = qtyWrap.querySelector('.qb-chip[data-qty="' + qty + '"]');
            if (chosenChip) chosenChip.classList.add('qb-chip--active');
          } catch (e) { /* ignore DOM issues during initialization */ }
        }
        // mark the selection token again to ensure subsequent async work is fresh
        currentSelectionToken++;
      } else {
        // Instead of loadProductForCurrentSelection, fetch correct product for selectedQty
        let handle;
        if (selectedQty === 1) {
          handle = button.getAttribute('data-product-handle-1');
        } else if (selectedQty === 6) {
          handle = button.getAttribute('data-product-handle-6');
        } else {
          handle = button.getAttribute('data-product-handle-3');
        }
        if (!handle) handle = productHandleFromCard(button);
  const tokenBeforeFetch = currentSelectionToken;
  const signal = activeFetchController ? activeFetchController.signal : undefined;
  const product = handle ? await fetchProduct(handle, signal) : null;
  if (tokenBeforeFetch !== currentSelectionToken) return; // selection changed while fetching
  selectedProduct = product;
        // Pick first available variant for the new product
        const v = product?.variants?.find(x => x.available) || product?.variants?.[0];
        selectedVariant = v ? {
          id: v.id,
          title: v.title,
          price: Number(v.price) || 0,
          compareAtPrice: Number(v.compare_at_price) || 0
        } : null;
        renderVariants(product);
      }
      await updateQtyBoxes();
    }

    // Use current or reference product to compute qty chip blocks from a unit price
    async function updateQtyBoxes() {
      // capture token to detect if selection changed during async ops
      const tokenAtStart = currentSelectionToken;
      // Prefer currently selected context (with a specific variant if chosen)
      if (selectedCardBtn) {
        let handle;
        if (selectedQty === 1) {
          handle = selectedCardBtn.getAttribute('data-product-handle-1');
        } else if (selectedQty === 6) {
          handle = selectedCardBtn.getAttribute('data-product-handle-6');
        } else {
          handle = selectedCardBtn.getAttribute('data-product-handle-3');
        }
        updateLabelBasedOnQty(selectedQty); // Ensure CTA updates dynamically based on selectedQty
        // fallback if not set
        if (!handle) handle = productHandleFromCard(selectedCardBtn);
  const signal = activeFetchController ? activeFetchController.signal : undefined;
  const product = handle ? await fetchProduct(handle, signal) : null;

        // Debug output for handle and product
        if (window.DEBUG_QB) {
          const debugOut = {
            qty: selectedQty,
            handle,
            productTitle: product?.title,
            productHandle: product?.handle,
            variants: product?.variants?.map(v => ({
              id: v.id,
              title: v.title,
              price: v.price,
              available: v.available
            }))
          };
          console.log('[QB DEBUG]', JSON.stringify(debugOut, null, 2));
        }

        // For each qty, fetch the correct product and variant price
        const qtyHandles = {
          1: selectedCardBtn.getAttribute('data-product-handle-1'),
          3: selectedCardBtn.getAttribute('data-product-handle-3'),
          6: selectedCardBtn.getAttribute('data-product-handle-6')
        };
        for (const qty of [1, 3, 6]) {
          let handle = qtyHandles[qty];
          if (!handle) handle = productHandleFromCard(selectedCardBtn);
          // Use cache key: handle|qty|variantId (variantId only when the selectedVariant applies to this qty)
          const variantIdForKey = (selectedVariant && selectedQty === qty) ? selectedVariant.id : '';
          const cacheKey = `${handle}|${qty}|${variantIdForKey}`;
          if (perQtyPriceCache.has(cacheKey)) {
            const cachedUnit = perQtyPriceCache.get(cacheKey);
            setQtyChipPrice(qty, cachedUnit);
            continue;
          }
          const signal = activeFetchController ? activeFetchController.signal : undefined;
          const prod = handle ? await fetchProduct(handle, signal) : null;
          let unitCents = 0;
          // Always use the correct variant for the correct product context
          const v = prod ? (prod.variants.find(x => x.available) || prod.variants[0]) : null;
          if (selectedVariant && selectedQty === qty && prod) {
            // Find the variant in the correct product for the selectedVariant.id
            const vv = prod.variants?.find(x => x.id == selectedVariant.id);
            unitCents = vv ? Number(vv.price) || 0 : Number(selectedVariant.price) || 0;
          } else if (v) {
            unitCents = Number(v.price) || 0;
          }

          // If this offer card is a mixed bundle, the product variant price may be
          // the total bundle price (e.g. price for 3-pack). For display we need a
          // per-bag unit price — divide by qty when appropriate.
          const cardIsMixed = selectedCardBtn && selectedCardBtn.getAttribute('data-bundle-type') === 'mixed';
          if (cardIsMixed && qty > 1 && unitCents > 0 && !isEspressoPromotionsPage) {
            unitCents = Math.round(unitCents / qty);
          }
          // if selection changed while we were fetching, abort to avoid stale UI
          if (tokenAtStart !== currentSelectionToken) return;
          // store computed value in cache for future quick lookup
          perQtyPriceCache.set(cacheKey, unitCents);
          setQtyChipPrice(qty, unitCents);
        }
        return;
      }

      // No roast chosen yet — use the first available card as reference
      const first = offerButtons.find(b => !b.disabled);
      if (!first) return;
      const handle = productHandleFromCard(first);
      const product = handle ? await fetchProduct(handle) : null;
      const v = product?.variants?.find(x => x.available) || product?.variants?.[0];
      const unitCents = Number(v?.price) || 0;
      if (unitCents) {
        setQtyChipPrice(1, unitCents);
        setQtyChipPrice(3, unitCents);
        setQtyChipPrice(6, unitCents);
      }
    }

    // Update labels dynamically based on the selected quantity
    function updateLabelBasedOnQty(selectedQty) {
      const qtyNumber = Number(selectedQty);

      // Update any "Includes Nx" labels (number only)
      // Do not update for qty=1 (mixed bundles never show this UI for 1 bag)
      if (Number.isFinite(qtyNumber) && qtyNumber > 1) {
        document.querySelectorAll('.buybox-bags-quantity').forEach((el) => {
          el.textContent = String(qtyNumber);
        });
      }

      const ctaLabel = sectionRoot.querySelector('.lp-button-label');
      if (!ctaLabel) return;

      if (!Number.isFinite(qtyNumber) || qtyNumber < 1) {
        ctaLabel.textContent = 'Get your selection';
        return;
      }

      if (qtyNumber === 1) {
        ctaLabel.textContent = 'Get 1 Bag - $6.95 Shipping';
        return;
      }

      ctaLabel.textContent = `Get ${qtyNumber} Bags - Free Shipping`;
    }

    // Function to update the class of .row based on the selected bundle type
function updateRowClass(bundleType) {
  const qtyRow = document.querySelector('#qb-qty-options .row');
  if (qtyRow) {
    // remove any existing bags-* classes
    Array.from(qtyRow.classList).forEach(c => {
      if (/^bags-\d+$/.test(c)) qtyRow.classList.remove(c);
    });

    const bags = bundleType === 'mixed' ? 2 : 3;
    qtyRow.classList.add('bags-' + String(bags));
  }
}

// Events — Step 1
    offerButtons.forEach((btn) => {
      const overlays = btn.querySelectorAll('.qb-check-icon, .qb-ribbon');
      overlays.forEach(el => (el.style.pointerEvents = 'none'));
      btn.addEventListener('click', () => selectOffer(btn));
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOffer(btn); }
      });
    });

    // Step 2 — variants
    variantWrap.addEventListener('click', async (e) => {
      // invalidation token: variants selection may trigger async product loads
  currentSelectionToken++;
  // Cancel previous fetches and create a fresh controller for this user action
  try { if (activeFetchController) activeFetchController.abort(); } catch(e){}
  activeFetchController = new AbortController();
  // clear visible prices while we load the new variant/product
  showLoadingState();
      const chip = e.target.closest('.qb-chip');
      if (!chip || chip.matches('.qb-chip--disabled, [aria-disabled="true"]')) return;

      variantWrap.querySelectorAll('.qb-chip').forEach((c) => c.classList.remove('qb-chip--active'));
      chip.classList.add('qb-chip--active');

      const grindValue = chip.dataset.grindValue || chip.dataset.variantKey || chip.dataset.variantTitle;
      const newKey = (grindValue || '').trim().toLowerCase();
      console.log('[QB] preferredVariantKey set by chip click:', newKey);
      preferredVariantKey = newKey;
      lastSelectedGrindKey = newKey; // Always remember last grind selection
      if (isMixedBundle) {
        const product = selectedProduct;
        // For mixed bundle, find the variant where ALL options match the selected grind
        const variant = product.variants.find(v => {
          return product.options.every((opt, idx) => {
            const val = v[`option${idx + 1}`];
            return (val || '').trim().toLowerCase() === preferredVariantKey;
          });
        });
          if (variant) {
            selectedVariant = {
              id: variant.id,
              title: sanitizeVariantTitle(variant.title),
              price: Number(variant.price) || 0,
              compareAtPrice: Number(variant.compare_at_price) || 0,
            };
        } else {
          selectedVariant = null;
        }
  // Update summary AND refresh all qty chip prices so non-active chips
  // (e.g. the other bundle sizes) show correct per-bag pricing for
  // the newly-selected grind in mixed bundles.
  updateSummary();
  await updateQtyBoxes();
  // small hotfix: re-click selected Step-1 after a short delay to ensure
  // any dependent state/UI refreshes properly.
  scheduleReselectCard();
  return;
      }

      if (!selectedCardBtn) {
        selectedVariant = null;
        setLPButton(0, false);
        updateSummary();
        return;
      }

      // Always fetch the correct product for the selected quantity
      let handle;
      if (selectedQty === 1 && selectedCardBtn) {
        handle = selectedCardBtn.getAttribute('data-product-handle-1');
      } else if (selectedQty === 6 && selectedCardBtn) {
        handle = selectedCardBtn.getAttribute('data-product-handle-6');
      } else if (selectedCardBtn) {
        handle = selectedCardBtn.getAttribute('data-product-handle-3');
      }
      if (!handle && selectedCardBtn) handle = productHandleFromCard(selectedCardBtn);
  const product = handle ? await fetchProduct(handle, activeFetchController.signal) : null;
  selectedProduct = product;
      // Find the variant matching the selected grind/variant
      const v = product?.variants?.find(x => x.id == chip.dataset.variantId);
        if (v) {
        selectedVariant = {
          id: v.id,
          title: sanitizeVariantTitle(v.title),
          price: Number(v.price) || 0
        };
      } else {
        // Only set selectedVariant if it matches the correct product context
        selectedVariant = null;
      }
      updateSummary();
      updateQtyBoxes();
      // small hotfix: re-click selected Step-1 after a short delay to ensure
      // any dependent state/UI refreshes properly.
      scheduleReselectCard();
    });

    // Step 3 — qty
    qtyWrap.querySelectorAll('.qb-chip').forEach((chip) => {
      chip.addEventListener('click', async () => {
        // Changing qty invalidates in-flight updates
  currentSelectionToken++;
  // Cancel previous fetches and create a fresh controller for this user action
  try { if (activeFetchController) activeFetchController.abort(); } catch(e){}
  activeFetchController = new AbortController();
  // clear visible prices while we load the new product/qty
  showLoadingState();
        qtyWrap.querySelectorAll('.qb-chip').forEach((c) => c.classList.remove('qb-chip--active'));
        chip.classList.add('qb-chip--active');
        selectedQty = parseInt(chip.dataset.qty, 10) || 3;
        updateLabelBasedOnQty(selectedQty); // Call the function here to update the CTA button

        // When qty changes, fetch correct product/variant for that qty
        let handle;
        if (selectedQty === 1) {
          handle = selectedCardBtn?.getAttribute('data-product-handle-1');
        } else if (selectedQty === 6) {
          handle = selectedCardBtn?.getAttribute('data-product-handle-6');
        } else {
          handle = selectedCardBtn?.getAttribute('data-product-handle-3');
        }
        if (!handle) handle = productHandleFromCard(selectedCardBtn);
  const product = handle ? await fetchProduct(handle, activeFetchController.signal) : null;
        selectedProduct = product;
        // Pick first available variant for the new product
        const v = product?.variants?.find(x => x.available) || product?.variants?.[0];
        selectedVariant = v ? {
          id: v.id,
          title: sanitizeVariantTitle(v.title),
          price: Number(v.price) || 0,
          compareAtPrice: Number(v.compare_at_price) || 0
        } : null;

        await updateQtyBoxes();
        updateSummary();
        // small hotfix: re-click selected Step-1 after a short delay to ensure
        // any dependent state/UI refreshes properly.
        scheduleReselectCard();
      });
    });

    // Hidden checkout
    if (btnCheckout) {
      btnCheckout.addEventListener('click', (e) => {
        e.preventDefault();
        if (!allReady()) {
          (selectedCardBtn ? (variantWrap || sectionRoot) : (offerButtons[0] || sectionRoot))
            .scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        // For mixed bundle, always add 1 bundle product (which contains 3 or 6 items)
        if (isMixedBundle) {
          const url = `/cart/${selectedVariant.id}:1`;
          window.location.href = url;
        } else {
          const url = `/cart/${selectedVariant.id}:${selectedQty}`;
          window.location.href = url;
        }
      });
    }

    // Visible CTA
    if (lpButton) {
      lpButton.addEventListener('click', async (e) => {
        e.preventDefault();
        if (!allReady()) {
          (selectedCardBtn ? (variantWrap || sectionRoot) : (offerButtons[0] || sectionRoot))
            .scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        try {
          const quantityToAdd = isMixedBundle ? 1 : selectedQty;
          const lineItemProperties = getLockCartQuantityProperties(selectedCardBtn, selectedQty);
          if (window.ensureShippingProtectionBeforeAdd) {
            await window.ensureShippingProtectionBeforeAdd(null);
          }
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: selectedVariant.id,
              quantity: quantityToAdd,
              properties: lineItemProperties
            })
          });
          if (window.ensureShippingProtection) {
            await window.ensureShippingProtection(null);
          }
          openSideCart();
        } catch (err) {
          console.error('Failed to add bundle to cart', err);
          // Fallback to the previous redirect behavior if add fails
          const url = `/cart/${selectedVariant.id}:${isMixedBundle ? 1 : selectedQty}`;
          window.location.href = url;
        }
      });
    }

    // Init
    safeHitAreas();
    if (lpButton) lpButton.disabled = true;
    updateLabelBasedOnQty(selectedQty);
    setOneBagOptionVisibility(false);

    // Honor preselected card if present
    const pre = offerButtons.find(b => isVisible(b) && (b.classList.contains('is-selected') || b.dataset.preselect === 'true'));
    const firstVisible = offerButtons.find(b => isVisible(b));
    (async () => {
      if (pre) {
        await selectOffer(pre);
      } else if (firstVisible) {
        await selectOffer(firstVisible);
      } else {
        // show variants in preview mode from the first card
        const first = offerButtons.find(b => !b.disabled);
        if (first) {
          try {
            const product = await fetchProduct(productHandleFromCard(first));
            selectedProduct = product; // just for rendering
            renderVariants(product);
          } catch (e) { D.error(e); }
        }
      }
      await updateQtyBoxes();  // fill qty chip prices (using per-bag price)
      updateSummary();
    })();

    // Center the horizontal scroll position of Step 3 chips row on page load (mobile)
    var qtyRow = document.querySelector('#qb-qty-options .row');
    if (qtyRow && qtyRow.scrollWidth > qtyRow.clientWidth) {
      qtyRow.scrollLeft = (qtyRow.scrollWidth - qtyRow.clientWidth) / 2;
    }
  }

  // Ensure DOM ready when script is external
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }




// Initial call to set the correct state on page load
//toggleStep2Wrapper();


})();

jQuery(document).ready(function($) {
    const params = new URLSearchParams(window.location.search);

    if (params.get('decaf') === 'true') {
        $('.qb-category-tabs button[data-category="decaf"]').css('display', 'block');
    }
});
